import Api from 'src/services/Api';
import { WORKSPACES_URL } from 'src/config/urls';
import { PaginatedFetchResult, PaginationJSON } from '../../../types';
import { ScimTokenJSON } from '../models/ScimToken';
import { ScimAuditLogJSON } from '../models/ScimAuditLog';

type GenerateScimTokenResponseJSON = {
	token: string;
}

export default class ScimSystem {
	private api: Api;

	constructor( { api }: { api: Api } ) {
		this.api = api;
	}

	async fetchScimToken( { workspaceID }: { workspaceID: number } ): Promise<ScimTokenJSON> {
		const url = `${WORKSPACES_URL}/${workspaceID}/scim_token`;
		const response = await ( this.api.get( url ) as Promise<{ response: ScimTokenJSON }> );
		return response.response;
	}

	async generateScimToken( { workspaceID }: { workspaceID: number } ): Promise<string> {
		const url = `${WORKSPACES_URL}/${workspaceID}/scim_token`;
		const response = await ( this.api.post( url ) as Promise<{ response: GenerateScimTokenResponseJSON }> );
		return response.response.token;
	}

	async fetchScimAuditLogs(
		{ workspaceID, page }: { workspaceID: number, page: number }
	): Promise<PaginatedFetchResult<ScimAuditLogJSON>> {
		const url = `${WORKSPACES_URL}/${workspaceID}/scim_audit_logs?page=${page}`;
		const response = await ( this.api.get( url ) as Promise<{
			response: ScimAuditLogJSON[],
			pagination: PaginationJSON
		}> );
		return { items: response.response, pagination: response.pagination };
	}
}
